import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { EtiquetadoContextService } from "../../context/etiquetado-context.service";
import { EtiquetadoService } from "../../services/etiquetado.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-mantenimiento-incidencias',
    templateUrl: './mantenimiento-incidencias.component.html'
})
export class MantenimientoIncidenciasComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public toCloseSpinner = 0;
    public exportModal = 0;

    public deleteModal = false;
    public newEditModal = false;

    public incidencias;
    public almacenes;
    public confecciones;
    public municipios;
    public provincias;
    public denominaciones;
    public campanyas;
    public etiquetadores;
    public marcas;

    public paisId;
    public denominacionId;
    public incidenciaId;
    public consumoId;
    public incidenciaGestionada;

    public reimpresionesModal = false;

    public disabledAlmacenes: Subject<boolean> = new Subject();
    public disabledMunicipios: Subject<boolean> = new Subject();
    public disabledConfecciones: Subject<boolean> = new Subject();
    public disabledProvincias: Subject<boolean> = new Subject();
    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledCampanyas: Subject<boolean> = new Subject();
    public disabledEtiquetadores: Subject<boolean> = new Subject();
    public disabledMarcas: Subject<boolean> = new Subject();

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showWarning: boolean;

    public dropdownInfo: number;
    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public orderBy: string;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly _router: Router,
        private _fb: UntypedFormBuilder,
        private readonly _translate: TranslateService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _etiquetadoContext: EtiquetadoContextService,
        private readonly _dataProvider: DataProvider,
        private readonly _utilsService: UtilsService,
        private readonly _sessionContext: SessionContextService
    ) { }


    ngOnInit() {
        this.filtersForm = this._fb.group({
            pais: ['', Validators.required],
            denominacion: [{ value: '', disabled: true }, Validators.required],
            campanya: [{ value: '', disabled: true }, Validators.required],
            provincia: [{ value: '', disabled: true }],
            municipio: [{ value: '', disabled: true }],
            etiquetador: [{ value: '', disabled: true }],
            confeccion: [{ value: '', disabled: true }],
            almacen: [{ value: '', disabled: true }],
            marca: [{ value: '', disabled: true }],
            paisDestino: [''],
            finca: [''],
            productor: [''],
            licencia: [''],
            consumo: [''],
            snc: [''],
            estado: [''],
            fechaIncidencia: [''],
            fechaGestionada: [''],
            fechaConsumo: [''],
        });

        this._etiquetadoContext.mantenimientoIncidenciasFilters = null;

        if (this.rolePermission) {
            this.filtersForm.get('pais').clearValidators();
            this.filtersForm.get('pais').updateValueAndValidity();
            this.filtersForm.get('denominacion').clearValidators();
            this.filtersForm.get('denominacion').updateValueAndValidity();
            this.filtersForm.get('campanya').clearValidators();
            this.filtersForm.get('campanya').updateValueAndValidity();
            this.getIncidencias();
            if(this.estadosIncidencia) this.filtersForm.get('estado').patchValue(this.estadosIncidencia[1]);
        } else {
            this.checkWarnings(this.filtersForm.get('pais').value);
        }

        this.filtersForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this.paisId = pais.id;
                this.getProvinciasByPais(pais.id);
                this.getDenominacionesByPais(pais.id);
            } else {
                this.disabledProvincias.next(true);
                this.disabledDenominaciones.next(true);
                this.provincias = [];
                this.denominaciones = [];
                this.filtersForm.get('provincia').patchValue('');
                this.filtersForm.get('provincia').disable();
                this.filtersForm.get('denominacion').patchValue('');
                this.filtersForm.get('denominacion').disable();
            }
        });

        this.filtersForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                this.getCampanyasByDenominacion(denominacion.id, this.paisId);
            } else {
                this.disabledCampanyas.next(true);
                this.campanyas = [];
                this.filtersForm.get('campanya').patchValue('');
                this.filtersForm.get('campanya').disable();
            }
        });

        this.filtersForm.get('campanya').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((campanya) => {
            if (campanya) {
                this.getEtiquetadoresByCampanya(campanya.id);
            } else {
                this.disabledEtiquetadores.next(true);
                this.etiquetadores = [];
                this.filtersForm.get('etiquetador').patchValue('');
                this.filtersForm.get('etiquetador').disable();
            }
        });

        this.filtersForm.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
            if (etiquetador) {
                this.getConfeccionesByEtiquetador(etiquetador.id);
                this.getAlmacenesByEtiquetador(etiquetador.id);
                this.getMarcasByEtiquetador(etiquetador.id);
            } else {
                this.disabledConfecciones.next(true);
                this.disabledAlmacenes.next(true);
                this.disabledMarcas.next(true);
                this.confecciones = [];
                this.almacenes = [];
                this.marcas = [];
                this.filtersForm.get('confeccion').patchValue('');
                this.filtersForm.get('confeccion').disable();
                this.filtersForm.get('almacen').patchValue('');
                this.filtersForm.get('almacen').disable();
                this.filtersForm.get('marca').disable();
                this.filtersForm.get('marca').patchValue('');
            }
        });

        this.filtersForm.get('provincia').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((provincia) => {
            if (provincia) {
                this.getMunicipiosByProvincia(provincia.id);
            } else {
                this.disabledMunicipios.next(true);
                this.municipios = [];
                this.filtersForm.get('municipio').patchValue('');
                this.filtersForm.get('municipio').disable();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get paises() {
        const paisesFiltrados = this.role === 'Administrador' ? this._dataProvider.paises : this._dataProvider.paises.filter(x => x.tienePDConGestionIncidencias);

        if (paisesFiltrados) {
            if (paisesFiltrados === 1 && this.filtersForm.get('pais').enabled) {
                this.filtersForm.get('pais').patchValue(paisesFiltrados[0]);
                this.filtersForm.get('pais').disable();
            }
        }
        return paisesFiltrados;
    }

    public get destinos() {
        return this._dataProvider.destinos;
    }

    public get rolePermission() {
        return this._sessionContext.sessionUser.role === 'Administrador';
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get tiposConsumo() {
        return this._dataProvider.tiposConsumo;
    }

    public get estadosIncidencia() {
        return this._dataProvider.estadosIncidencia;
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    public getProvinciasByPais(paisId) {
        let filters = {
            paisId: paisId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getProvinciasByPaisId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.provincias = resp.lista;
                this.filtersForm.get('provincia').enable();
                this.disabledProvincias.next(false);
            }
        });
    }

    public getMunicipiosByProvincia(provinciaId) {
        let filters = {
            provinciaId: provinciaId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getMunicipiosByProvinciaId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.municipios = resp.lista;
                this.filtersForm.get('municipio').enable();
                this.disabledMunicipios.next(false);
            }
        });
    }

    public getDenominacionesByPais(paisId) {
        let filters = {
            paisId,
            tienePDConGestionIncidencias: true
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getDenominaciones(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.denominaciones = resp.lista;
                if (this.denominaciones.length === 1) {
                    this.filtersForm.get('denominacion').patchValue(this.denominaciones[0]);
                    this.filtersForm.get('denominacion').disable();
                    this.disabledDenominaciones.next(true);
                } else {
                    this.filtersForm.get('denominacion').enable();
                    this.disabledDenominaciones.next(false);
                }
            }
        });
    }

    public getCampanyasByDenominacion(denominacionId, paisId) {
        let filters = {
            denominacionId: denominacionId,
            paisId: paisId,
            volcadoHistorico: false
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getCampanyas(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.campanyas = resp.lista;
                this.campanyas.forEach(campanya => {
                    campanya.des = campanya.anyo.toString();
                });
                this.filtersForm.get('campanya').patchValue(this.campanyas[0]);
                this.filtersForm.get('campanya').enable();
                this.disabledCampanyas.next(false);
            }
        });
    }

    public getEtiquetadoresByCampanya(campanyaId) {
        let filters = {
            campanyaId: campanyaId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getEtiquetadores(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.etiquetadores = resp.lista;

                if (this.etiquetadores.length === 1) {
                    this.filtersForm.get('etiquetador').patchValue(this.etiquetadores[0]);
                } else {
                    this.filtersForm.get('etiquetador').enable();
                    this.disabledEtiquetadores.next(false);
                }
            }
        });
    }

    public getConfeccionesByEtiquetador(etiquetadorId) {
        let filters = {
            etiquetadorId: etiquetadorId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getConfecciones(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.confecciones = resp.lista;
                this.filtersForm.get('confeccion').enable();
                this.disabledConfecciones.next(false);
            }
        });
    }

    public getAlmacenesByEtiquetador(etiquetadorId) {
        let filters = {
            etiquetadorId: etiquetadorId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getAlmacenesByEtiquetadorId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.almacenes = resp.lista;
                this.filtersForm.get('almacen').enable();
                this.disabledAlmacenes.next(false);
            }
        });
    }

    public getMarcasByEtiquetador(etiquetadorId) {
        let filters = {
            paisId: this.paisId,
            etiquetadorId: etiquetadorId,
            denominacionId: this.denominacionId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getMarcas(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.marcas = resp.lista;
                this.marcas.unshift({ id: -1, des: this._translate.instant('global.sinMarca') });
                this.filtersForm.get('marca').enable();
                this.disabledMarcas.next(false);
            }
        });
    }

    private checkWarnings(pais) {
        if (pais && this.filtersForm.valid) {
            this.filtersVisible = false;
            this.showWarning = false;
            this.mensajes = [];
            this.getIncidencias();
        } else {
            this.filtersVisible = true;
            this.showWarning = true;
            this.mensajes.push({ class: 'warning', message: 'global.info.filterRequired' });
        }
    }

    public pageChange(page) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._etiquetadoContext.mantenimientoIncidenciasFilters.numPagina =
            this.currentPage = page - 1;
        this.getIncidencias();
    }

    public itemsPerPageChange(items) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._etiquetadoContext.mantenimientoIncidenciasFilters.numPagina =
            this.currentPage = 0;
        this._etiquetadoContext.mantenimientoIncidenciasFilters.tamPagina =
            this.itemsPerPage = items;
        this.getIncidencias();
    }

    public checkValuesForm(): boolean {
        return (
            (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            (this.filtersForm.get('denominacion').value && this.filtersForm.get('denominacion').enabled) ||
            this.filtersForm.get('campanya').value ||
            this.filtersForm.get('provincia').value ||
            this.filtersForm.get('municipio').value ||
            (this.filtersForm.get('etiquetador').value && this.filtersForm.get('etiquetador').enabled) ||
            this.filtersForm.get('confeccion').value ||
            this.filtersForm.get('almacen').value ||
            this.filtersForm.get('marca').value ||
            this.filtersForm.get('paisDestino').value ||
            this.filtersForm.get('finca').value ||
            this.filtersForm.get('productor').value ||
            this.filtersForm.get('licencia').value ||
            this.filtersForm.get('consumo').value ||
            this.filtersForm.get('snc').value ||
            this.filtersForm.get('estado').value ||
            this.filtersForm.get('fechaIncidencia').value ||
            this.filtersForm.get('fechaGestionada').value ||
            this.filtersForm.get('fechaConsumo').value) ? true : false;
    }

    public resetForm() {
        this.filtersForm.reset({
            pais: this.filtersForm.get('pais').disabled ? this.filtersForm.get('pais').value : null,
            denominacion: this.filtersForm.get('denominacion').disabled ? this.filtersForm.get('denominacion').value : null
        });
    }

    public filtrar() {
        if (this.filtersForm.invalid) {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        } else {
            this.applyFilters();
        }
    }

    private applyFilters() {
        this.currentPage = 0;
        this._etiquetadoContext.mantenimientoIncidenciasFilters = {
            paisId: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : null,
            denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : null,
            campanyaId: this.filtersForm.get('campanya').value ? this.filtersForm.get('campanya').value.id : null,
            provinciaId: this.filtersForm.get('provincia').value ? this.filtersForm.get('provincia').value.id : null,
            municipioId: this.filtersForm.get('municipio').value ? this.filtersForm.get('municipio').value.id : null,
            etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : null,
            almacenId: this.filtersForm.get('almacen').value ? this.filtersForm.get('almacen').value.id : null,
            marcaId: this.filtersForm.get('marca').value ? this.filtersForm.get('marca').value.id : null,
            paisDestinoId: this.filtersForm.get('paisDestino').value ? this.filtersForm.get('paisDestino').value.id : null,
            desFinca: this.filtersForm.get('finca').value ? this.filtersForm.get('finca').value : '',
            confeccionId: this.filtersForm.get('confeccion').value ? this.filtersForm.get('confeccion').value.id : null,
            codigoSNC: this.filtersForm.get('snc').value ? this.filtersForm.get('snc').value : '',
            nLicencia: this.filtersForm.get('licencia').value ? this.filtersForm.get('licencia').value : '',
            desProductor: this.filtersForm.get('productor').value ? this.filtersForm.get('productor').value : '',
            tipoConfeccionConsumo: this.filtersForm.get('consumo').value ? this.filtersForm.get('consumo').value.value : null,
            gestionada: this.filtersForm.get('estado').value ? this.filtersForm.get('estado').value.value : '',
            fechaIncidencia: this.filtersForm.get('fechaIncidencia').value ?
                this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaIncidencia').value) : '',
            fechaGestionada: this.filtersForm.get('fechaGestionada').value ?
                this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaGestionada').value) : '',
            fechaConsumo: this.filtersForm.get('fechaConsumo').value ?
                this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaConsumo').value) : '',
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage,
        };

        this.getIncidencias();
    }

    public getIncidencias() {
        if (this._etiquetadoContext.mantenimientoIncidenciasFilters) {
            this._filters = this._etiquetadoContext.mantenimientoIncidenciasFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getIncidencias(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.incidencias = resp.lista;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public create() {
        this.incidenciaId = null;
        this.consumoId = null;
        this.newEditModal = true;
    }

    public update(incidencia) {
        this.incidenciaId = incidencia.id;
        this.consumoId = incidencia.consumoId;
        this.incidenciaGestionada = incidencia.gestionada;
        this.newEditModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.deleteIncidencia(this.incidenciaId).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getIncidencias();
        });
    }

    public askDelete(incidencia) {
        this.incidenciaId = incidencia.id;
        this.deleteModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public showDetails(i: number) {
        if (!this.newEditModal && !this.deleteModal) {
            this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
            // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
            if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
                // Retardo en caso de que haya otro panel abierto
                setTimeout(() => {
                    document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
                }, 50);
            }
        }
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public pushMessage(mensaje) {
        this.mensajes = [];
        if (mensaje) {
            this.showWarning = true;
            this.mensajes.push({ class: 'success', message: mensaje });
        } else {
            this.showWarning = false;
            this.mensajes = [];
        }
    }

    public refresh(value) {
        // if (value && this.filtersForm.get('etiquetador').value !== '') {
        //     this.getIncidencias();
        // }
        if (value) {
          this.getIncidencias();
        }
        this.reimpresionesModal = false;
    }

    public showReimpresiones(incidencia) {
        this.reimpresionesModal = true;
        this.consumoId = incidencia.consumoId;
    }

    private downloadPdf() {
        this.toCloseSpinner += 1;
        this._etiquetadoService.getRepIncidenciasPdf(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            const downloadLink = document.createElement('a');
            downloadLink.href = 'data:application/pdf;base64,' + resp.base64Archivo;
            downloadLink.download = resp.nombreArchivo;
            downloadLink.click();
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.file' });
        });
    }

    private downloadCsv() {
        this.toCloseSpinner += 1;
        this._etiquetadoService.getRepIncidenciasCsv(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            const downloadLink = document.createElement('a');
            downloadLink.href = 'data:text/csv;base64,' + resp.base64Archivo;
            downloadLink.download = resp.nombreArchivo;
            downloadLink.click();
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.file' });
        });
    }

    public exportPdfOrCsv(type) {
        if (this.incidencias && this.incidencias.length > 0) {

            if (this._etiquetadoContext.mantenimientoIncidenciasFilters) {
                this._filters = {...this._etiquetadoContext.mantenimientoIncidenciasFilters};
                this._filters.tamPagina = 0;
                this._filters.tipoArchivo = this.exportModal === 1 ? 'Pdf' : 'Csv';
                this._filters.muestraDesIncidenciaYRespuestaGST = type === 2;
            }
            
            this._spinnerService.showSpinner();
            this.exportModal === 1 ? this.downloadPdf() : this.downloadCsv();
        } else {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.exportNoData' });
        }

        this.exportModal = 0;
    }

    public getIcon(prop: string) {
      let iconClass = 'fa fa-sort';
      if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty.indexOf(prop) != -1) {
          iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
  }

  public toOrderBy(columnFilter, idColumn) {
    if (this.incidencias && this.incidencias.length > 0) {
        if (this._etiquetadoContext.mantenimientoIncidenciasFilters) {
            this._filters = this._etiquetadoContext.mantenimientoIncidenciasFilters;
        }
    }

    if (!this.orderBy || this.orderBy.includes('DESC')) {
        this.orderBy = 'ASC' + idColumn;
        this._filters.orderItems = [
            {
            orderProperty: columnFilter,
            orderByDescending: false
            }
        ];
    } else if (this.orderBy.includes('ASC')) {
        this.orderBy = 'DESC' + idColumn;
        this._filters.orderItems = [
            {
                orderProperty: columnFilter,
                orderByDescending: true
            }
        ];
    }

    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._etiquetadoService.getIncidencias(this._filters).toPromise().finally(() => {
        this.checkCloseSpinner();
    }).then((resp) => {
        this.incidencias = resp.lista;
    });
  }

  public openDocHelp() {
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._etiquetadoService.getDocHelp('Labeling_Incidences.pdf').toPromise().finally(() => {
        this.checkCloseSpinner();
    }).then((resp) => {
        localStorage.setItem('base64', resp.base64Archivo);
        const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
        window.open(url, '_blank');
    });
  }

  public trackByIncidenciaId(index: number, incidencia: { id: number }): number {
    return incidencia.id;
  }
}
